import React, { useEffect, useRef, useState } from "react";
import { forceUpdate, skipWaiting, hasWaitingSW } from "../../../serviceWorkerRegistration";

const COUNTDOWN_SECONDS = 5;
const TICK_MS = 50; // płynność paska (50ms = ~20fps)

const UpdateNotification = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [updateType, setUpdateType] = useState("sw");
  const [message, setMessage] = useState("");
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);
  const [progressPct, setProgressPct] = useState(100);
  const [readyToReload, setReadyToReload] = useState(false);
  const isMobile = window.innerWidth < 992;
  const triggeredRef = useRef(false);
  const timerRef = useRef(null);
  const endAtRef = useRef(0);
  const lastKeyRef = useRef(null);

  const isMysql = process.env.REACT_APP_LOCAL_DB === "true";

  const getUpdateMessage = (type) => {
    switch (type) {
      case "app":
        return "Dostępna jest nowa wersja aplikacji.";
      case "cache":
        return "Zawartość została zaktualizowana w tle.";
      default:
        return "Wykryto nową wersję oprogramowania.";
    }
  };

  const cleanupFlags = () => {
    sessionStorage.removeItem("isUpdateAvailable");
    sessionStorage.removeItem("updateType");
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const startCountdown = () => {
    stopTimer();

    const durationMs = COUNTDOWN_SECONDS * 1000;
    endAtRef.current = Date.now() + durationMs;

    setSecondsLeft(COUNTDOWN_SECONDS);
    setProgressPct(100);

    timerRef.current = setInterval(() => {
      const msLeft = Math.max(0, endAtRef.current - Date.now());
      const pct = (msLeft / durationMs) * 100;

      setProgressPct(pct);

      // sekundy liczymy stabilnie
      const sec = Math.ceil(msLeft / 1000);
      setSecondsLeft(sec);

      if (msLeft <= 0) {
        stopTimer();
        runUpdate(updateType);
      }
    }, TICK_MS);
  };

  const runUpdate = async (type) => {
    if (triggeredRef.current) return;
    triggeredRef.current = true;

    stopTimer();
    cleanupFlags();

    try {
      if (type === "app") {
        forceUpdate();
        return;
      }

      await skipWaiting();

      // fallback (jakby controllerchange nie złapało)
      setTimeout(() => {
        window.location.replace(
          window.location.pathname + window.location.search
        );
      }, 2500);
    } catch (e) {
      window.location.replace(window.location.pathname + window.location.search);
    }
  };

  useEffect(() => {
      if (!updateAvailable) return;

      const t = setInterval(async () => {
        const reg = await navigator.serviceWorker.getRegistration();
        setReadyToReload(!!reg?.waiting);
      }, 300);

      return () => clearInterval(t);
    }, [updateAvailable]);

  useEffect(() => {
    const checkExistingUpdate = () => {
      const isUpdateAvailable = sessionStorage.getItem("isUpdateAvailable");
      const storedUpdateType = sessionStorage.getItem("updateType") || "sw";

      if (isUpdateAvailable === "true" && !isMysql) {
        triggeredRef.current = false;

        setUpdateAvailable(true);
        setUpdateType(storedUpdateType);
        setMessage(getUpdateMessage(storedUpdateType));
        startCountdown();
      }
    };


    const handleUpdateAvailable = async (event) => {
      if (isMysql) return;

      const type = event?.detail?.type || "sw";
      const msg = event?.detail?.message || getUpdateMessage(type);
      const version = event?.detail?.version || "unknown";

      const key = `${type}:${version}`;
      if (lastKeyRef.current === key) return;
      lastKeyRef.current = key;

      const maxWaitMs = 8000;
      const start = Date.now();

      while (Date.now() - start < maxWaitMs) {
        const ready = await hasWaitingSW();
        if (ready) break;
        await new Promise((r) => setTimeout(r, 250));
      }

      const ready = await hasWaitingSW();
      if (!ready) {
        return;
      }

      sessionStorage.setItem("isUpdateAvailable", "true");
      sessionStorage.setItem("updateType", type);

      triggeredRef.current = false;

      setUpdateAvailable(true);
      setUpdateType(type);
      setMessage(msg);

      startCountdown();
    };


    checkExistingUpdate();
    window.addEventListener("app-update-available", handleUpdateAvailable);

    return () => {
      stopTimer();
      window.removeEventListener("app-update-available", handleUpdateAvailable);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMysql]);

  if (!updateAvailable || isMysql) return null;

  return (
<div className={`${!isMobile && "end-0"} position-fixed top-0 p-3`} style={{ zIndex: 1050 }}>
  <div
    className="alert alert-info shadow-sm border-0 rounded-4 mb-0"
    role="alert"
    style={{ width: 400, maxWidth: "calc(100vw - 24px)" }}
  >
    <h6 className="alert-heading mb-1 fw-bold">
      Aktualizacja portalu dostępna
    </h6>

    <div
      className="small text-dark"
      style={{ opacity: 0.85, fontVariantNumeric: "tabular-nums" }}
    >
      Za <b>{secondsLeft}s</b> nastąpi automatyczna aktualizacja portalu.
    </div>

    <div className="d-flex align-items-center mt-2">
      <div
        className="progress flex-grow-1"
        style={{ height: 7, borderRadius: 999, overflow: "hidden" }}
      >
        <div
          className="progress-bar"
          role="progressbar"
          style={{
            width: `${Math.max(0, Math.min(100, progressPct))}%`,
            borderRadius: 999,
            transition: `width ${TICK_MS}ms linear`,
          }}
        />
      </div>
    </div>
  </div>
</div>
);
};

export default UpdateNotification;
